import "../admin/style.css";
import "../admin/custom.css";
import { useEffect, useState, createElement } from "@wordpress/element";
import { createRoot } from "@wordpress/element";
import WidgetApp from "./widget-wrapper";

document.addEventListener("DOMContentLoaded", function () {
	const mountNode = document.createElement("div");
	mountNode.id = "accessibility-widget-parent";
	document.body.appendChild(mountNode);
	const root = createRoot(mountNode);
	root.render(<WidgetApp />);
});
